export default __webpack_public_path__ + "img/8fc9c56e9b5e5c6b6c7832347e42823e.svg";